<template>
<div class="main h-100 hero pt-100 background-img">
    <div class="container overflow-auto h-100 px-20">
        <div class="row h-100 ">
            <div class="col-sm-12">
                <div class="header-logo header-logo my-12 py-12">
                    <img src="@/assets/media/logos/fpdtkd_white.png" class="h-150px mr-6" alt="FDPTKD">
                    <!--<div class="text-uppercase text-white border-left px-6">
                        <p>Federación Deportiva Peruana de <strong>Taekwondo</strong></p>
                    </div>-->
                </div>
            </div>
            <div class="col-sm-12">
                <h1 class="text-white" style="line-height:1.2">Sistema Nacional de <br>Acreditación</h1>
                <p class="lead text-white my-4">Únete a nosotros, selecciona una de las siguientes opciones</p>
                <div class="my-8 options">
                    
                    <router-link to="/events" tag="button" class="btn btn-pill font-size-h5 px-8 py-3 mr-3 btn-outline-white text-white text-hover-danger font-weight-bolder">Eventos</router-link>
                    <!--<button type="button" class="btn btn-pill font-size-h5 px-8 py-3 mr-3 btn-outline-white text-white text-hover-danger font-weight-bolder">Capacitaciones</button>-->
                    <a href="https://sistema.hayllis.com/fdptkd/"  target="_blank" class="btn btn-pill font-size-h5 px-8 py-3 mr-3 btn-outline-white text-white text-hover-danger font-weight-bolder">
                        Acreditación
                    </a>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
export default {
    name: "Portada"
}
</script>

<style>
.hero {
    background: url('https://static.actu.fr/uploads/2021/01/tuarai-hery-action-ok.jpg')no-repeat center center / cover;
}

.background-img:before {
    position: absolute;
    content: '';
    background-image: linear-gradient(to right, rgb(173 15 37 / 95%), rgb(149 55 46 / 95%), rgb(177 49 49 / 70%), rgb(205 48 48 / 65%), rgb(230 41 41 / 55%));
    /*background-image: linear-gradient(to right, rgba(177, 17, 22, 0.65), rgba(177, 17, 22, 0.65), rgba(177, 17, 22, 0.60), rgba(177, 17, 22, 0.55), rgba(177, 17, 22, 0.65));*/
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}

.hero h1 {
    font-weight: 700;
    font-size: 42px;
    line-height: 60px;
}

.hero .lead {
    font-size: 1.25rem;
    font-weight: 300;
}
</style>
